const QUERIES = {
  USERS_LIST: 'users-list',
  TIPS_LIST: 'tips-list', 
}

export {QUERIES}
